import React from 'react'
import './blogCards.css'
import { Link } from 'react-router-dom'

import arrow from '../../assets/icons/arrow-right-s-line.svg'

const BlogCards = ({img, heading, text, path}) => {
  return <div className='blog__card'>
    <Link to={path}><img src={img} alt="" /></Link>
    <div className="blog__card-bottom">
        <Link to={path}><h2 className='blog__card-heading'>{heading}</h2></Link>
        <p className='blog__card-text'>{text}</p>
        <Link to={path} className='blog__card-link'>Read More <img className='arrow_link' src={arrow} alt="" /></Link>
    </div>
  </div>
}

export default BlogCards